import { useEffect } from "react";
import { useLocation, useNavigate } from "react-router";
import BackBtn from "../../../components/Template/Buttons/BackBtn";
import "./OrganizationDetailPage.css";

import { Spin } from "antd";
import { useSelector } from "react-redux";
import AssignTemplatesTable from "../../../components/SettingModuleComponent/OrganizationDetailComponent/AssignTemplatesTable/AssignTemplatesTable";
import AssignUserModal from "../../../components/SettingModuleComponent/OrganizationDetailComponent/AssignUserTable/AssignUserModal/AssignUserModal";
import AssignUserTable from "../../../components/SettingModuleComponent/OrganizationDetailComponent/AssignUserTable/AssignUserTable";
import DeleteTemplateConfirmModal from "../../../components/SettingModuleComponent/OrganizationDetailComponent/ConfirmTemplateDeleteModal/ConfirmTemplateDeleteModal";
import DeleteUserConfirmModal from "../../../components/SettingModuleComponent/OrganizationDetailComponent/ConfirmUserDeleteModal/ConfirmUserDeleteModal";
import { closeAssignUserModal, closeDeleteTemplateConfirmationModal, closeDeleteUserConfirmationModal, getOrganizationDetail, openAssignUserModal, openDeleteTemplateConfirmationModal, openDeleteUserConfirmationModal, resetOrganizationDetailPage } from "../../../redux/SettingModule/OrganizationDetailPage/OrganizationDetailAction";
import { RootState } from "../../../redux/store";
import { useAppDispatch } from "../../../redux/useAppDispatch";

function OrganizationDetailPage(props: any) {
  const navigate = useNavigate();
  const dispatch = useAppDispatch();
  const location = useLocation();
  const id = location.pathname.split("/").pop();
  useEffect(() => {
    dispatch(getOrganizationDetail(id));
    return () => {
      dispatch(resetOrganizationDetailPage());
    };
  }, []);

  const backActionClick = () => {
    navigate(-1);
  };
  const organizationDetailData = useSelector((state: RootState) => state.OrganizationDetailPageState.data);
  const deleteUserConfirmOpenState = useSelector((state: RootState) => state.OrganizationDetailPageState.userDeleteConfirmationModalState);
  const deleteTemplateConfirmOpenState = useSelector((state: RootState) => state.OrganizationDetailPageState.templateDeleteConfirmationModalState);
  const createOrganizationDetailModalState = useSelector((state: RootState) => state.OrganizationDetailPageState.createOrganizationDetailModalState);
  const loading = useSelector((state: RootState) => state.OrganizationDetailPageState.loading);

  if (loading) {
    return (
      <div
        className="app"
        style={{
          textAlign: "center",

          display: "flex",

          alignItems: "center",

          justifyContent: "center",
        }}>
        <Spin size="large" />
      </div>
    );
  }

  return (
    <div className="body-container gap-3">
      <DeleteUserConfirmModal
        tenantId={Number(id)}
        openState={deleteUserConfirmOpenState}
        open={() => dispatch(openDeleteUserConfirmationModal())}
        close={() => dispatch(closeDeleteUserConfirmationModal())}
      />
      <DeleteTemplateConfirmModal
        openState={deleteTemplateConfirmOpenState}
        open={() => dispatch(openDeleteTemplateConfirmationModal())}
        close={() => dispatch(closeDeleteTemplateConfirmationModal())}
      />
      <AssignUserModal
        tenantId={Number(id)}
        openState={createOrganizationDetailModalState}
        open={() => dispatch(openAssignUserModal())}
        close={() => dispatch(closeAssignUserModal())}
      />

      <div className="d-flex align-items-center gap-3 justify-content-between mb-3">
        <div className="d-flex align-items-center gap-3">
          <BackBtn
            backActionClick={() => backActionClick()}
            backPath="/live"
          />
          <span className="title">Organization Name:</span>

          <span className="title">{organizationDetailData.name}</span>
        </div>
        {/* <div className="d-flex align-items-center gap-1">
          <button
            className="button"
            onClick={() => console.log("clicked")}>
            Save & Exit
          </button>
          <button
            onClick={() => {
              console.log("clicked");
            }}
            className="button danger">
            Delete
          </button>
        </div> */}
      </div>
      <div className="d-flex gap-3">
        <div className="w-50">
          <AssignUserTable data={organizationDetailData.users} />
        </div>
        <div className="w-50">
          <AssignTemplatesTable data={organizationDetailData.templates} />
        </div>
      </div>
    </div>
  );
}

export default OrganizationDetailPage;
